import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ArticlePage from "../pages/article/page";
import ArticleDynamicPage from "../pages/article-dynamic/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/guia-cssbuy-sheet/",
    element: <ArticlePage />,
  },
  {
    path: "/artigo/:slug/",
    element: <ArticleDynamicPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;